import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react';
import React from 'react';

interface WarningModalProps {
  visible: boolean;
  title: string;
  message: string;
  loading?: boolean;
  onYes: () => void;
  onNo: () => void;
}

/**
 * Warning modal component with two action buttons: Yes and No
 * Used to display warning messages that require user confirmation
 */
export const WarningModal: React.FC<WarningModalProps> = ({
  visible,
  title,
  message,
  loading = false,
  onYes,
  onNo,
}) => {
  return (
    <CModal visible={visible} onClose={onNo} backdrop="static">
      <CModalHeader closeButton={false}>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>{message}</CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onNo} disabled={loading}>
          No
        </CButton>
        <CButton color="warning" onClick={onYes} disabled={loading}>
          {loading ? 'Processing...' : 'Yes'}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
